/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_DocumentInputs */

const cs_entity_picker_placeholder_document = /** @type {(inputs: Entity_Picker_Placeholder_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat dokument (název souboru)`)
};

const en_entity_picker_placeholder_document = /** @type {(inputs: Entity_Picker_Placeholder_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search document (file name)`)
};

/**
* | output |
* | --- |
* | "Search document (file name)" |
*
* @param {Entity_Picker_Placeholder_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_document = /** @type {((inputs?: Entity_Picker_Placeholder_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_document(inputs)
	return cs_entity_picker_placeholder_document(inputs)
});